/* Light Armor — QuickSpark financing chip on quote-only pages (added 2026-08-29).
 *
 * On Add-to-Cart pages la-buy-skin.js parks the chip on the Add to Cart row,
 * right-aligned beside the button. Quote-only units (dedicated-truck freight) have
 * no such row, so that code skips them and the chip was left where QuickSpark
 * mounts it — floating under the price, far from the ask.
 *
 * Give the quote block the same treatment: wrap "Request a Quote" in a flex row and
 * seat the chip beside it. The button gives up the width the chip needs (it is
 * flex:1 with min-width:0, so it shrinks rather than overflowing) and the pattern
 * reads identically to the BTO pages.
 *
 * QuickSpark re-renders its widget back into its own mount point whenever it
 * recalculates, so placing it once is not enough: watch for it and move it back.
 * Moving it hits the "already in place" branch, so this cannot loop.
 */
(function () {
  'use strict';
  if (window.__laFinQuote) return;
  window.__laFinQuote = true;

  var CSS =
    '.la-quote__finrow{display:flex;align-items:center;gap:10px}' +
    '.la-quote__finrow > .la-quote__open{flex:1 1 auto;min-width:0}' +
    '.la-fin--quote{flex:0 0 auto;transform:scale(.92);transform-origin:right center;' +
    'transition:transform .12s,filter .15s;cursor:pointer}' +
    '.la-fin--quote br{display:none}' +
    '.la-fin--quote:hover{transform:scale(.92) translateY(-1px);filter:brightness(1.06)}' +
    /* Narrow columns: stack rather than squeeze the button to nothing. */
    '@media(max-width:560px){.la-quote__finrow{flex-wrap:wrap}' +
    '.la-quote__finrow > .la-quote__open{flex:1 1 100%}' +
    '.la-fin--quote{margin:6px auto 0;transform-origin:center top}}';

  function addStyles() {
    if (document.getElementById('la-fin-quote-css')) return;
    var s = document.createElement('style');
    s.id = 'la-fin-quote-css';
    s.textContent = CSS;
    (document.head || document.documentElement).appendChild(s);
  }

  var queued = false;
  function place() {
    queued = false;
    var fin = document.querySelector('.ls-detail-button-cont');
    var btn = document.querySelector('.la-quote__open');
    if (!fin || !btn || !btn.parentNode) return;

    var row = document.querySelector('.la-quote__finrow');
    if (!row || !row.contains(btn)) {
      row = document.createElement('div');
      row.className = 'la-quote__finrow';
      btn.parentNode.insertBefore(row, btn);
      row.appendChild(btn);
    }
    if (fin.parentNode === row) return;   /* already in place */
    fin.classList.add('la-fin--quote');
    row.appendChild(fin);
  }
  function queue() { if (!queued) { queued = true; setTimeout(place, 60); } }

  function init() {
    if (!document.querySelector('.la-quote')) return;   /* quote-only pages */
    addStyles();
    place();
    new MutationObserver(queue).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
}());
